import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, FormControl, Select, InputLabel, MenuItem, Icon, Fab } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from './RenderTextFieldRedux';
// import Typography from '@material-ui/core/Typography';
import RenderTextFieldReduxNumber from './RenderTextFieldReduxNumber';

let identificacion = {name: 'Cédula', value: 'cedule'}
const validate = (values) => {

    const error = {}
    
    if (identificacion.value === 'cedule' && !/^\d{10}$/.test(values.code)) {
      error.code = 'El número de cédula consta de 10 números';
    }
  
    if (identificacion.value === 'ruc' && !/^\d{13}$/.test(values.code)) {
      error.code = 'El número de Ruc consta de 13 números';
    }
  
    if (identificacion.value === 'passport' && !/^[a-zA-Z0-9]+$/.test(values.code)) {
      error.code = 'El número de pasaporte consta de números y letras';
    }
    console.log(error.code, 'valuescoderror')
    return error;
   }

   const normalizeAll = (value) => {
    if (!value) {
        return value;
    }
    const alphanumericOnly = value.replace(/[^0-9a-zA-Z]/g, '');
    return alphanumericOnly;
}

const BeneficiaryFindAccount = props => {
    //console.log('props', props)
    const { handleSubmit, selectype, onCloseBeneficiaryForm/* , setDocument, document */ } = props
    console.log('props', props)
    const [data] = React.useState([
    { name: 'Cédula', value: 'cedule' },
    { name: 'Ruc', value: 'ruc' },
    { name: 'Pasaporte', value: 'passport' },
    //{ name: 'Número de cuenta', value: 'account' }
])
    const [labelText, setLabelText] = React.useState('Cédula')

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={3} justifyContent="flex-start" alignItems="center" >
                {/* <Grid item xs={12} md={8}>
                    <Field
                        name="document"
                        id="document"
                        required
                        row
                        data={
                            [
                                { label: 'Cédula', value: '1' },
                                { label: 'RUC', value: '2' },
                                { label: 'PASAPORTE', value: '6' },
                                { label: 'NUMERO DE CUENTA', value: '7' },
                            ]
                        }
                        //document={document}
                        component={RenderRadioGroup}
                        label="Buscar por"
                        setVal={setDocument}
                        valor={document}
                        onChange={(event) => {
                            // console.log('event', event)
                        }}(val) => {
                            const { value } = val.target
                            selectype(value)
                            setLabelText(value.name)
                            // console.log(value)
                        }
                        //values={document}
                    >
                    </Field>
                </Grid> */}
                <Grid item xs={12} md={12}>
                    <FormControl variant="outlined" style={{ width: '100%' }}>
                        <InputLabel id="demo-simple-select-outlined-label">{'Buscar por'}</InputLabel>
                        <Select
                            fullWidth
                            label={'Buscar por'}
                            labelId="demo-simple-select-label"
                            id="entity"
                            defaultValue={data[0]}
                            onChange={(val) => {
                                const { value } = val.target
                                identificacion = (value)
                                selectype(value)
                                setLabelText(value.name)
                            }}
                        >
                            {
                                data.map(option => {
                                    return <MenuItem key={option.value} value={option}>{`${option.name}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={8} md={8}>
                <Field
                        key={labelText}
                        name="code"
                        id="code"
                        required
                        component={labelText === 'Ruc' ? RenderTextFieldReduxNumber : labelText === 'Pasaporte' ? RenderTextFieldRedux : labelText === 'Cédula' ? RenderTextFieldReduxNumber : null }
                        label={labelText}
                        type="text"
                        maxLength={labelText === 'Cédula' ? 10 : labelText === 'Ruc' ? 13 : null}
                        normalize={labelText === 'Pasaporte' ? normalizeAll: normalizeAll}
                        fullWidth
                />                      
                </Grid>
                {/* <Grid item xs={4} md={2} container direction="column" justifyContent="flex-start" alignItems="center">
                    <Tooltip title="Consultar" aria-label="buscar">
                        <Fab aria-label="buscar" type="submit">
                            <img src={process.env.PUBLIC_URL + '/buttons/buscar.png'} alt="Logo" style={{ width: '100%' }} />
                        </Fab>
                    </Tooltip>
                    <Typography component="h2" variant="h6" gutterBottom style={{
                        //fontFamily: "MyriadPro-SemiBold",
                        color: "#000000",
                        fontSize: "120%",
                        marginTop: '5px'
                    }}>
                        CONSULTAR
                    </Typography>
                </Grid> */}
                <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                    <Fab color='primary' aria-label="add" type="submit" >
                        <Icon style={{ color: "#FFFFFF" }}>search</Icon>
                    </Fab>
                </Grid>
                <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                    <Fab style={{ backgroundColor: 'red' }} aria-label="add" onClick={onCloseBeneficiaryForm} >
                        <Icon style={{ color: "#FFFFFF" }}>close</Icon>
                    </Fab>
                </Grid>
            </Grid>
        </form>
    );
};

BeneficiaryFindAccount.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    valid: PropTypes.bool.isRequired
};
const FindAccountReduxForm = reduxForm(
    {
        form: 'FindAccountForm',
        validate
    }
)(BeneficiaryFindAccount)
export default setPropsAsInitial(FindAccountReduxForm)
// export default BeneficiaryFindAccount;